import { useCardState, withCardStateProvider } from '@/ui/elements/contexts';
import { ProfileCard } from '@/ui/elements/ProfileCard';

import { localizationKeys } from '../../customizables';
import { ActiveDevicesSection } from './ActiveDevicesSection';
import { SecurityDelete, SecurityMfa, SecurityPasskeys, SecurityPassword } from './SecuritySections';

export const SecurityPage = withCardStateProvider(() => {
  const card = useCardState();

  return (
    <ProfileCard.Page>
      <ProfileCard.PagePanel
        pageId='security'
        titleKey={localizationKeys('userProfile.start.headerTitle__security')}
        alertContent={card.error}
      >
        <SecurityPassword />
        <SecurityPasskeys />
        <SecurityMfa />
        <ActiveDevicesSection />
        <SecurityDelete />
      </ProfileCard.PagePanel>
    </ProfileCard.Page>
  );
});
